var Vendd = (function (Vendd) {
	'use strict';

    var pending = false;
	var pendingSessionStatus = true;
	var pendingRedirectAfterLogin = false;

	var getVisitorState = function getVisitorState() {

		var cookie = $.cookie("VisitorState");

		var options = {
			url: 'CmsService.svc/InitVisitorState',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (cookie) {
			return cookie;
		} else {
			Vendd.Service.Call(options);
		};

		function onSuccess(response) {
			cookie = $.cookie("VisitorState");

			if (response.success && cookie) {
				return cookie;
			};
		};

		function onFailure(response) {
			console.log(response);
		};
	};

	var setVisitorState = function setVisitorState(cookie) {

		if (cookie) {

			var oldUrl = window.location.href;
			var cookieValueAsUrl = "?" + cookieValue;

		}
	};

	Vendd.User.AuthProviders = (function (AuthProviders) {
		return AuthProviders;
	})(Vendd.User.AuthProviders || {});

	var _logoutRedirectUrl = '';

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/Login',
			data: {
				loginName: envelope.message.data.loginName,
				password: envelope.message.data.password,
				rememberMe: envelope.message.data.rememberMe,
				reCaptchaCode: envelope.message.data.reCaptchaCode
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

        function onSuccess(response) {
            if (response.success) {
                pendingRedirectAfterLogin = true;

                var model = JSON.parse(response.data);
                model = model ? $.extend({}, model, { LangCode: LhApp.Context.Language }) : model;
                Vendd.User.SetClientModel(model);

                response.loginName = envelope.message.data.loginName;
                response.password = envelope.message.data.password;
                _logoutRedirectUrl = model.LoginForm.LogoutRedirectUrl;

                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelSuccess(model));
            }
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginFailure(response));
		};

        Vendd.User.ClearClientModel();

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.ForgotPassword, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/ForgotPassword',
			data: envelope.message.data.email,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ForgotPasswordSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ForgotPasswordFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.ResetPassword, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/ResetPassword',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResetPasswordSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResetPasswordFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Logout, Vendd.User, function (envelope) {

		Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutAuthProviders());

	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutAuthProviders, Vendd.User, function (envelope) {

		var logoutPromises = [];

		_.each(Vendd.User.AuthProviders, function (provider) {
			if (typeof (provider.logout) === 'function' && provider.initiated) {

				var promise = $.Deferred(function (defer) {
					provider.logout(function () {
						defer.resolve();
						return defer.promise();
					});
				});

				logoutPromises.push(promise);
			}
		});

		$.when.apply($, logoutPromises).then(function () {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutUser());
		});

	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutUser, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/Logout',
			data: {},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			if (response.success) {
				var redirectUrl = _logoutRedirectUrl;
				$.cookie("ForceClearCartLocalStorage", 1);

				if (LhApp.Context.MultipleWishlistsEnabled)
				    Vendd.UserWishlist.ClearClientModel();

				if (redirectUrl && URI(redirectUrl).equals(document.location.pathname) === true) {
					Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutSuccess(response));
				} else if (redirectUrl) {
					document.location = redirectUrl;
				} else {
					var baseUrl = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/';
					document.location = baseUrl;
				};
            }

		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutFailure(response));
		};

        Vendd.User.ClearClientModel();

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Register, Vendd.User, function (envelope) {

		var preventRedirect = envelope.message.data.preventRedirect;

		var options = {
			url: 'AuthService.svc/Register',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {

			if (!response.success) return onFailure(response);

			if (response.success && response.code === "Registration_OperationSuccesful") {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterSuccess(response));

				if (!preventRedirect) {
					Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginRedirect(envelope));
				}

			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterFailure(response));
		};

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.CanRegister, Vendd.User, function (envelope) {

        var options = {
            url: 'AuthService.svc/CanRegister',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (!response.success) return onFailure(response);

            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CanRegisterSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CanRegisterFailure(response));
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegister, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/B2BRegister',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.B2BRegisterSuccess(response));
			if (response.success && response.code === "Registration_OperationSuccesful" && response.data.login) {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginRedirect(envelope));
			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.B2BRegisterFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.CreateUser, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/CreateUser',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CreateUserSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CreateUserFailure(response));
		};

		Vendd.Service.call(options);
    });

    /*we are using this event which is raised after session has been checked to load the model and(if dirty clear local storage)*/
    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.User, function (envelope) {
        pending = false;
        pendingSessionStatus = false;
        if (envelope.message.data.IsNewSession)
            Vendd.User.ClearClientModel();

        if (venddProjectConfigs.UserModelEnabled) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModel, Vendd.User, function (envelope) {

        if (pending === true) {
            return false;
        };

        if (pendingSessionStatus) {
            pending = true;
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionState());
            return false;
        }

        var model = Vendd.User.GetClientModel();

        var useModelFromLocalStorage = model && document.cookie.indexOf('ForceClearUserLocalStorage') === -1;
        if (model && !model.hasOwnProperty("RegisterForm")) //VENDDTHREE-2419: structural change of model we expect this property filled || null
            useModelFromLocalStorage = false;

        if (useModelFromLocalStorage) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelSuccess(model));
            return true;
        }

        var options = {
            url: 'UserService.svc/GetUserViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
            data: { templateCode: LhApp.Context.Item ? LhApp.Context.Item.Template : "" },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		function onSuccess(response) {
		    model = response ? $.extend({}, response, { LangCode: LhApp.Context.Language }) : response;
		    Vendd.User.SetClientModel(model);

            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelSuccess(response));
			pending = false;
		};

		function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelFailed(response));

            pending = false;
		};

		$.removeCookie('ForceClearUserLocalStorage', { path: '/' });
		pending = true;

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.QuoteSubmit, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/QuoteSubmit',
			data: {
				email: envelope.message.data.email,
				userName: envelope.message.data.userName,
				message: envelope.message.data.message,
				skuId: envelope.message.data.skuId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.QuoteSubmitSuccess(response));
			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.QuoteSubmitFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginRedirect, Vendd.User, function (envelope) {

		var loginName = envelope.message.data.loginName || envelope.message.data.email || envelope.message.data.username;

		var redirectUrl = envelope.message.data.redirectUrl;

		/*if redirect is not defined reload page */
		if (!redirectUrl) {
			redirectUrl = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/';
		}

		var loginmessage = new Vendd.User.Messages.Login(loginName, envelope.message.data.password, envelope.message.data.rememberMe, redirectUrl);
		Vendd.MessageBus.publishAsync(Vendd.User, loginmessage);
	});

    Vendd.User.ClearClientModel = function () {
        localStorage.removeItem('CurrentUserModel');
    };

    Vendd.User.GetClientModel = function () {
        var mdl = JSON.parse(localStorage.getItem("CurrentUserModel"));

        return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
    };

    Vendd.User.SetClientModel = function (mdl) {
        localStorage.setItem('CurrentUserModel', JSON.stringify(mdl));
    };

	return Vendd;

})(Vendd || {});



function onSignIn(googleUser) {
	var profile = googleUser.getBasicProfile();
	var id_token = googleUser.getAuthResponse().id_token;
};
